import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import modalsSelector from '../../selectors/modals';

const ErrorModal = () => {
  const {
    errorModalOpen: open,
    errorModalTitle: title,
    errorModalMessage: message,
  } = useSelector(modalsSelector);
  const navigate = useNavigate();
  return (
    <Dialog aria-labelledby="quick-invoice-dialog-title" open={open}>
      <DialogTitle id="quick-invoice-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="quick-invoice-dialog-description">
          {message}
        </DialogContentText>
        <DialogActions>
          <Button
            onClick={() => {
              navigate(-1);
            }}
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorModal;
